import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./ToggleSwitch.scss";

export const ToggleSwitch = ({
  value = false,
  onChange,
  label = "",
  labels = [],
  className,
  disabled = false,
}) => {
  const isTabMode = Array.isArray(labels) && labels.length === 2;

  const handleChange = (newValue) => {
    if (disabled) return;
    onChange(newValue);
  };

  return (
    <div className={classNames("toggle-switch", className, { disabled })}>
      {isTabMode ? (
        <div className="tab-toggle">
          <div
            className={classNames("tab", { active: value })}
            onClick={() => handleChange(true)}
          >
            {labels[0]}
          </div>
          <div
            className={classNames("tab", { active: !value })}
            onClick={() => handleChange(false)}
          >
            {labels[1]}
          </div>
        </div>
      ) : (
        <>
          <label className="switch">
            <input
              type="checkbox"
              checked={value}
              disabled={disabled}
              onChange={(e) => handleChange(e.target.checked)}
            />
            <span className="slider"></span>
          </label>
          {label && (
            <span className="label" onClick={() => handleChange(!value)}>
              {label}
            </span>
          )}
        </>
      )}
    </div>
  );
};

ToggleSwitch.propTypes = {
  label: PropTypes.string,
  labels: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};
